module.exports = __webpack_public_path__ + "media/src/images/notfound-icon8-4b70cc11c027a44d1d60529bd0b8319d.png";